module.exports = __webpack_public_path__ + "img/9_24.22d0d5e9.png";